module.exports = __webpack_public_path__ + "static/media/Andar_Bahar.0a548ed5.png";